import { Outlet, Link } from "react-router-dom";

import logo from "../../assets/logo.svg";

const Layout = () => {
    return (
        <div className="flex flex-col h-full">
            <div className="bg-j-white z-[100] hidden md:block" id={"header"}>
                <div className="items-center flex justify-center h-[80px] pb-4 pt-4 relative lg:pb-0 lg:pt-0">
                    <Link to="https://www.jerseyfsc.org" className="">
                        <img src={logo} alt="Jersey Financial Services Commission" className="" />
                    </Link>
                </div>
            </div>
            <Outlet />
        </div>
    );
};

export default Layout;
